<!-- 订单页面快照  -->
<template>
    <el-dialog title="订单页面快照" :visible.sync="centerDialogVisible" width="30%" center>
        <div v-loading="loading" v-if="JSON.stringify(datas) !== '{}'" class="container">
            <div @click="handlerbtnsClick()" class="yuan">
                <i :class="isShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="icons"></i>
            </div>
            <!-- <div class="span1" style="position: absolute;right: 0;top: -34rpx;">
                    <span class="span1" style="color: #456575;margin-right: 12rpx;">商品ID{{ datas.id }}</span>
                    <span class="span1" style="#DB4E1A;margin-right: 12rpx;">{{ datas.saleOptionTime < new Date().getTime()
                        ? '无效期' : '有效期' }}</span>
                            <span class="span1" style="color: #3697CA;">{{ datas.status == 2 ? '上架' : '待上架' }}</span>
                </div> -->
            <div class="containerBox" :class="isShow ? 'active' : 'isActive'">
                <div class="left">
                    <div class="leftText1">
                        {{ resourceName }}******
                    </div>
                    <!-- <div class="leftText2">
                    中国，海南，海口，美兰区，航安一街5号
                </div> -->
                    <div class="leftText3" v-if="orderType != 5 && orderType != 1">
                        <!-- <span>可提供房型{{ 1 }}</span> -->
                        <div class="price">
                            <span style="font-size: 0.12rem">总价</span>
                            <span style="font-size: 0.16rem">{{ totalPrice }}</span>
                            <span style="font-size: 0.12rem">{{ datas.stockList[0].currency }}</span>
                        </div>
                    </div>
                    <div class="leftText4" v-if="datas.productNameCn">
                        {{ datas.productNameCn }}
                    </div>
                    <div v-for="(items, indexs) in datas.stockList" :key="indexs">
                        <div v-if="orderType != 5 && orderType != 1" class="leftText5"
                            style="display: flex;align-items: center;flex-wrap: wrap;">
                            <span style="margin-right: 0.05rem;" v-if="datas.state === 0">{{ items.startDate }} 至 {{
                                addOneDay(items.endDate) }}</span>
                            <span style="margin-right: 0.05rem;" v-else-if="items.startDate == items.endDate">{{
                                items.endDate
                            }}</span>
                            <span style="margin-right: 0.05rem;;" v-else>{{ items.startDate }} 至 {{ items.endDate }}</span>
                            <span v-if="items.timeType == 4">
                                {{ items.timeTypeRemark[0] }}-{{ items.timeTypeRemark[1] }}</span>
                            <span v-else>{{ timeFrameCl(items.timeType, items.timeTypeRemark) }}</span>
                        </div>
                        <!-- <div class="contentBox" v-if="datas.stockType == 1">
                        <div class="contentdiv2" v-for="(item, index) in fitPricediv" :key="index">
                            <span class="name">
                                {{ item.name }}
                            </span>
                            <span class="price">
                                {{ items.stockPrice[item.keys] }}
                                <span style="font-size: 12rpx">{{ items.currency }}</span>
                            </span>
                        </div>
                    </div> -->
                        <div class="leftText5" v-else>
                            <span style="margin-right: 0.05rem;">{{ items.startTime | dateFormat }} 至 {{
                                items.endTime | dateFormat }} {{ items.timeType }}</span>
                        </div>
                        <div class="leftText4" v-if="items.commodityNameCn || items.commodityNameEn">
                            {{ items.commodityNameCn ? items.commodityNameCn : items.commodityNameEn }}
                        </div>
                        <div class="leftText6">
                            <span class="leftText6-1">报价：</span>
                            <span class="leftText6-2">{{ items.salePrice }}{{ items.currency }}</span>
                            <span class="leftText6-3">/{{ items.priceUnit }} </span>
                            <span class="leftText6-3" style="font-size: 20rpx;">（市价：{{ items.storePrice ? items.storePrice :
                                0
                            }}{{ items.currency }}）</span>
                            <div v-if="orderType == 5 && orderType == 1">
                                <div class="leftText7" v-if="items.recommendation">
                                    推荐理由：{{ items.recommendation }}
                                </div>
                                <div class="leftText8" v-if="items.cancelType">
                                    {{ cancelTypeMap(items) }}
                                </div>
                            </div>
                            <span class="leftText6-2" v-if="orderType != 5 && orderType != 1"
                                style="margin-right: 12rpx;font-weight: 400;">{{ items.saleNumber }}{{ items.priceUnit }}
                                <span>{{ calculateDaysDifference(items.startDate, items.endDate) + 1 }}</span>{{
                                    items.useTime
                                }}</span>
                            <span class="leftText6-4" v-if="orderType != 5 && orderType != 1"> <span
                                    class="leftText5">共：</span>
                                {{ (items.salePrice * (calculateDaysDifference(items.startDate, items.endDate) + 1) *
                                    items.saleNumber).toFixed(2)
                                }}{{ items.currency }}</span>
                        </div>
                        <div v-if="datas.state == 2" class="leftText9">
                            团队票 (20人(含)至{{ items.cherish }}）/ 单日票 / 营业时间: 以景点为准 / 单次入内 /
                        </div>
                    </div>
                    <div class="leftText7" v-if="datas.recommendation">
                        推荐理由：{{ datas.recommendation }}
                    </div>
                    <div class="leftText8" v-if="orderType != 5 && orderType != 1">
                        {{ cancelTypeMap(datas) }} / Option {{ datas.saleOptionTime | dateFormatHms }}
                    </div>
                </div>
                <div class="right">
                    <div class="rightBtnList">
                        <div v-for="item in swBtnList" :key="item" class="rightBtns">
                            {{ item }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <commodityFacility :orderType="orderType" :state="facilityDatas.state" :datas="facilityDatas"></commodityFacility> -->
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="centerDialogVisible = false">关 闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import commodityFacility from "./commodityFacility/commodityFacility.vue";
import Api from "@/components/Api/index";
import { addOneDay, calculateDaysDifference, getGroup } from '@/assets/utils/unit'
import {
    contains,
    cancelPolicyList, otherStockDatas
} from '../commodity.js'
export default {
    components: {
        commodityFacility
    },
    data() {
        return {
            contains,
            cancelPolicyList,
            datas: {},
            loading: false,
            facilityDatas: {},
            isShow: true,
            addOneDay,
            orderType: '',
            resourceName: '',
            centerDialogVisible: false,
            calculateDaysDifference,
            timeFrame1: {
                0: {
                    time: "9:00～19:00",
                    type: "全天",
                },
                1: {
                    time: "9:00～12:00",
                    type: "上午",
                },
                2: {
                    time: "14:00～19:00",
                    type: "下午",
                },
                3: {
                    time: "17:00～22:00",
                    type: "晚上",
                },
                4: {
                    time: null,
                    type: "自定义",
                },
            },
            swBtnList: ['价格政策', '预定说明', '费用说明', '使用说明', '退改说明', '其它说明', '图片维护'],
        }
    },
    computed: {
        totalPrice() {
            let price = 0
            if (JSON.stringify(this.datas) !== '{}') {
                this.datas.stockList.forEach(item => {
                    price += item.salePrice * (this.calculateDaysDifference(item.startDate, item.endDate) + 1) * item.saleNumber
                })
            }
            return price.toFixed(2)
        },
    },
    watch: {},
    methods: {
        initClick(orderType, id, resourceName) {
            this.orderType = orderType
            this.resourceName = resourceName
            this.centerDialogVisible = true
            if (orderType == 1 || orderType == 5) {
                this.getBudget(id)
            } else {
                this.getExclusive(id)
            }
            // this.getExclusive(id)
        },
        dataProcessingEvents(datas) {
            console.log(datas, '时刻打开打开');
            if (datas.state == 6) {
                for (const keys in datas.otherStockData) {
                    if (keys == 'acceptanceCrowd') {
                        datas.otherStockData[keys] = JSON.parse(datas.otherStockData[keys])
                    }
                    break;
                }
            }
            let containsCl
            if (this.orderType != 1 && this.orderType != 5) {
                if (datas.contains.length > 0) {
                    containsCl = getGroup(datas.contains, 'type')
                    this.$set(datas, 'contains', getGroup(this.contains, 'type'))
                    for (const key in datas.contains) {
                        if (containsCl[key]) {
                            datas.contains[key] = containsCl[key]
                        }
                    }
                } else {
                    this.$set(datas, 'contains', getGroup(this.contains, 'type'))
                }
            }
            let cancelPolicyObj = JSON.parse(JSON.stringify(this.cancelPolicyList))
            if (datas.cancelPolicyList.length == 0) {
                this.$set(datas, 'cancelPolicyList', cancelPolicyObj)
            } else {
                cancelPolicyObj[datas.cancelType] = datas.cancelPolicyList
                this.$set(datas, 'cancelPolicyList', cancelPolicyObj)
            }
            if (!datas.otherStockData) {
                if (otherStockDatas[datas.state]) {
                    this.$set(datas, 'otherStockData', JSON.parse(JSON.stringify(otherStockDatas[datas.state])))
                }
            }
            return datas
        },
        //获取专属
        getExclusive(id) {
            this.loading = true
            // new Api('resource').exclusiveDetail({ id:'1755510473723985921' }).then((res) => {
            new Api('resource').exclusiveDetail({ id: id }).then((res) => {
                if (res.status === 200) {
                    this.datas = res.data
                    this.datas.stockList = JSON.parse(JSON.stringify(res.data.prices))
                    this.datas.stockList.forEach(items => {
                        this.$set(items, 'startDate', "2024-07-20")
                        this.$set(items, 'endDate', '2024-07-21')
                    })
                    this.facilityDatas = res.data
                    this.facilityDatas.prices.forEach(item => {
                        item.days = JSON.parse(item.days)
                        item.year = item.days
                    })
                    this.facilityDatas = this.dataProcessingEvents(this.facilityDatas)
                    console.log(this.facilityDatas, '是看看打开打开的');
                    this.loading = false
                }
            })
        },
        //获取预算
        getBudget(id) {
            this.loading = true
            new Api('resource').customStockDetail([id]).then((res) => {
                if (res.status === 200) {
                    this.facilityDatas = this.dataProcessingEvents(res.data[0].categoryList[0].stockList[0])
                    this.datas = res.data[0].categoryList[0]
                    this.loading = false
                }
            })
        },
        timeFrameCl(type, time) {
            let result
            if (type != 4 && this.timeFrame1[type]) {
                result = this.timeFrame1[type].type + this.timeFrame1[type].time
                return result
            } else if (type) {
                result = this.timeFrame1[type].type + time
                return result
            }
        },
        cancelTypeMap(obj) {
            const map = {
                '1': "不可取消",
                '2': '入住当天' + obj.cancelTime + '前可免费取消',
                '3': '有条件退',
                '4': '有条件退',
                '5': '随时退(未使用可随时申请退款)',
            }
            return map[obj.cancelType]
        },
        handlerbtnsClick() {
            this.isShow = !this.isShow
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.active {
    min-height: 1rem;
}

.isActive {
    overflow: hidden;
    height: 0.45rem;
}

.disable-click {
    pointer-events: none;
}

.container {
    border-radius: 0.1rem;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 0.04rem 0.16rem 0 rgba(0, 0, 0, 0.17);
    position: relative;
    margin-bottom: 0.2rem;

    .containerBox {
        display: flex;
    }

    .yuan {
        position: absolute;
        top: -0.15rem;
        left: 0.05rem;
        width: 0.3rem;
        height: 0.3rem;
        background-color: #ECECEC;
        border-radius: 50%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;

        .icons {
            font-size: 0.25rem;
            cursor: pointer;
        }
    }

    .text1 {
        font-size: 18rpx;
        font-family: PingFangSC-regular;
    }

    .btns {
        padding: 0 10rpx;
        height: 46rpx;
        line-height: 46rpx;
        border-radius: 20rpx 20rpx 20rpx 20rpx;
        background-color: rgba(236, 236, 236, 1);
        text-align: center;
        color: rgba(230, 74, 25, 1);
        font-size: 24rpx;
        font-family: PingFangSC-regular;
    }

    .left {
        flex: 1;
        margin-right: 20rpx;
        padding: 0.17rem 0.16rem 0.16rem 0.18rem;

        .leftText1 {
            font-size: 0.18rem;
            color: rgba(0, 0, 0, 1);
            font-family: PingFangSC-semiBold;
        }

        .leftText2 {
            color: rgba(79, 109, 125, 1);
            font-size: 0.12rem;
            font-family: PingFangSC-regular;
            margin-bottom: 0.1rem;
        }

        .leftText3 {
            display: flex;
            justify-content: space-between;
            color: rgba(230, 74, 25, 1);
            font-size: 0.14rem;
            font-family: PingFangSC-light;

            .price {
                color: rgba(16, 16, 16, 1);
                font-family: PingFangSC-regular;
                border-bottom: 2px solid #F7E0D9;
                margin-left: auto;
            }
        }

        .leftText4 {
            display: flex;
            align-items: center;
            color: rgba(16, 16, 16, 1);
            font-size: 0.16rem;
            font-weight: bold;
            margin-bottom: 0.05rem;
        }

        .leftText5 {
            color: #000;
            font-size: 0.15rem;
            font-family: PingFangSC-medium;
            margin-bottom: 0.05rem;
        }

        .leftText6 {
            margin-bottom: 0.05rem;

            .leftText6-1 {
                color: rgba(230, 74, 25, 1);
                font-family: PingFangSC-light;
            }

            .leftText6-2 {
                color: #000;
                font-family: PingFangSC-regular;
                font-weight: bold;
                margin-right: 0.05rem;
            }

            .leftText6-3 {
                color: #000;
                font-family: PingFangSC-regular;
            }

            .leftText6-4 {
                color: rgba(176, 3, 3, 1);
                font-weight: bold;
                font-family: PingFangSC-medium;
            }
        }

        .leftText7 {
            color: rgba(176, 3, 3, 1);
            font-family: PingFangSC-light;
            margin-right: 18rpx;
            margin-bottom: 0.05rem;
        }

        .leftText8 {
            color: rgba(21, 89, 105, 1);
            font-family: PingFangSC-regular;
        }

        .leftText9 {
            color: rgba(79, 109, 125, 1);
            font-size: 20rpx;
            font-family: PingFangSC-regular;
            margin-bottom: 12rpx
        }
    }

    .right {
        width: 120rpx;

        .rightBtnList {
            .rightBtns {
                width: 0.7rem;
                line-height: 32rpx;
                padding: 0.01rem;
                border-radius: 3px;
                background-color: rgba(242, 237, 237, 1);
                text-align: center;
                color: rgba(230, 74, 25, 1);
                font-family: PingFangSC-light;
                margin-bottom: 0.02rem;


                &:nth-last-child(1) {
                    margin-bottom: 0;
                }
            }
        }
    }

    .contentBox {
        display: flex;
        align-items: center;
        margin: 10rpx 0;

        .contentView2 {
            padding: 10rpx;
            display: flex;
            align-items: center;
            flex-direction: column;
            margin-right: 10rpx;
            width: 68rpx;
            box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 2px, rgba(0, 0, 0, 0.2) 0px -2px 0px inset;

            .name {
                color: rgba(12, 63, 75, 1);
                font-size: 20rpx;
                font-family: PingFangSC-regular;
                margin-right: 6rpx
            }

            .price {
                color: rgba(16, 16, 16, 1);
                font-size: 21rpx;

            }

            font-family: PingFangSC-regular;
        }
    }
}
</style>